module.exports = __WEBPACK_EXTERNAL_MODULE_22__;


//////////////////
// WEBPACK FOOTER
// external "angular-resource"
// module id = 22
// module chunks = 0